const Permissions = {
    Candidate: {
        READ: 'candidate:read',
        DELETE: 'candidate:delete'
    },
    Vacancy: {
        READ: 'vacancy:read',
        DELETE: 'vacancy:delete'
    },
    Business_unit: {
        READ: 'business_unit:read',
        DELETE: 'business_unit:delete'
    },
    Contact: {
        READ: 'contact:read',
        DELETE: 'contact:delete'
    },
    Mail: {
        READ: {
            ALL: 'mail:read:all',
            DETAILS: 'mail:read:details',
            BY_ENTITY_RECORD: 'mail:read:by_entity_record',
        },
        DELETE: 'mails:delete:all'
    },

    Settings: {
        READ: 'settings:read'
    },
}

export default Permissions;